<template>
  <div class="guidance-tooltip__video-wrapper">
    <video
      class="guidance-tooltip__video"
      :src="url"
      :aria-label="description"
      :title="t('guidance.expandVideo')"
      muted
      autoplay
      loop
      playsinline
      @click="isExpanded = true"
    >
      <track kind="descriptions" />
    </video>

    <Teleport to="body">
      <div
        v-if="isExpanded"
        class="guidance-video-modal"
        @click.self="isExpanded = false"
      >
        <button
          type="button"
          class="guidance-video-modal__close"
          :title="t('guidance.closeVideo')"
          :aria-label="t('guidance.closeVideo')"
          @click="isExpanded = false"
        >
          ✕
        </button>
        <video
          class="guidance-video-modal__video"
          :src="url"
          :aria-label="description"
          muted
          autoplay
          loop
          playsinline
          controls
        >
          <track kind="descriptions" />
        </video>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onBeforeUnmount } from "vue";
import { useI18n } from "vue-i18n";

interface Props {
  url: string;
  description: string;
}

defineProps<Props>();

const { t } = useI18n();

const isExpanded = ref(false);

function handleKeydown(event: KeyboardEvent) {
  if (event.key === "Escape") isExpanded.value = false;
}

watch(isExpanded, (expanded) => {
  if (expanded) document.addEventListener("keydown", handleKeydown);
  else document.removeEventListener("keydown", handleKeydown);
});

onBeforeUnmount(() => {
  document.removeEventListener("keydown", handleKeydown);
});
</script>
